import React, { useState, useEffect } from "react";
import style from "./myTradeLimit.module.css";
import HeadLines from "../../../../CommonComponents/HeadLines";
import { isMobile } from "../../../../helperFunc";
import MultiProgressBar from "../MultiProgressBar/MultiProgressBar";
import { MoneyWallet } from "../../../../icon_assets";
import Button from "../../../../CommonComponents/Button";
import { getMyTradeList } from "../../../../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../../../../CustomToastr";
import useIsUserLoggedIn from "../../../../CustomHooks/useIsUserLoggedIn";
import FlexTitleComponent from "../FlexTitle/FlexTitleComponent";

const MyTradeLimit = () => {
  const [data, setData] = useState();
  const [userLoggedIn] = useIsUserLoggedIn();

  const getTradeData = async () => {
    try {
      const response = await getMyTradeList();
      if (response?.status_code === 200 && response?.data) {
        setData(response?.data);
      } else {
        customToastr({
          type: "warning",
          timeOut: 3000,
          text: response?.message || "Server Error",
        });
      }
    } catch (error) {
      customToastr({
        type: "warning",
        timeOut: 3000,
        text: error?.message,
      });
    }
  };

  useEffect(() => {
    if (userLoggedIn) {
      getTradeData();
    }
  }, [userLoggedIn]);

  const handleApply = () => {
    console.log("apply clicked");
  };

  return (
    <>
      {data?.totalLimit > 0 && (
        <div className="margin-top30">
          <FlexTitleComponent title="My Trade Limit" />
          <div className="margin-top24 margin-bottom20">
            <div
              className={`${style["my-trade-limitBox"]} margin-top24 margin-bottom20`}
            >
              {data ? (
                <>
                  <div>
                    <div className="d-flex align-items-center width-100">
                      <div className="width-100">
                        <HeadLines
                          text="Total Limit"
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark9 font-weight400`}
                        />
                        <HeadLines
                          text={`₹ ${data?.totalLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size20 line-height23 letterSpacing005"
                              : "font-size24 line-height28 letterSpacing015"
                          } colorDark1 font-weight700`}
                        />
                      </div>
                      <div className="d-flex align-items-center width-100 justify-content-space-around">
                        <div className="d-flex align-items-center gap10">
                          <div className={style["stpColorDiv"]} />
                          <HeadLines
                            text="STP Limit"
                            className={`${
                              isMobile
                                ? "font-size12 line-height14 letterSpacing005"
                                : "font-size14 line-height16 letterSpacing015"
                            } colorDark9 font-weight400`}
                          />
                        </div>
                        <HeadLines
                          text={`₹ ${data?.stpTotalLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark1 font-weight700 margin-left8`}
                        />
                        <div className="d-flex align-items-center gap10 margin-left8">
                          <div className={style["ltpColorDiv"]} />
                          <HeadLines
                            text="LTP Limit"
                            className={`${
                              isMobile
                                ? "font-size12 line-height14 letterSpacing005"
                                : "font-size14 line-height16 letterSpacing015"
                            } colorDark9 font-weight400`}
                          />
                        </div>
                        <HeadLines
                          text={`₹ ${data?.ltpTotalLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark1 font-weight700 margin-left8`}
                        />
                      </div>
                    </div>
                    <MultiProgressBar
                      totalLimit={data?.totalLimit}
                      stpLimit={data?.stpTotalLimit}
                      ltpLimit={data?.ltpTotalLimit}
                    />
                  </div>
                  <div className={`${isMobile ? `` : style["margintOP34"]}`}>
                    <div className="d-flex align-items-center width-100">
                      <div className="width-100">
                        <HeadLines
                          text="Utilized Limit"
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark9 font-weight400`}
                        />
                        <HeadLines
                          text={`₹ ${data?.utilizedLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size20 line-height23 letterSpacing005"
                              : "font-size24 line-height28 letterSpacing015"
                          } colorDark1 font-weight700`}
                        />
                      </div>
                      <div className="d-flex align-items-center width-100 justify-content-space-around">
                        <div className="d-flex align-items-center gap10">
                          <div className={style["stpColorDiv"]} />
                          <HeadLines
                            text="STP Limit"
                            className={`${
                              isMobile
                                ? "font-size12 line-height14 letterSpacing005"
                                : "font-size14 line-height16 letterSpacing015"
                            } colorDark9 font-weight400`}
                          />
                        </div>
                        <HeadLines
                          text={`₹ ${data?.stpUtilizedLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark1 font-weight700 margin-left8`}
                        />
                        <div className="d-flex align-items-center gap10 margin-left8">
                          <div className={style["ltpColorDiv"]} />
                          <HeadLines
                            text="LTP Limit"
                            className={`${
                              isMobile
                                ? "font-size12 line-height14 letterSpacing005"
                                : "font-size14 line-height16 letterSpacing015"
                            } colorDark9 font-weight400`}
                          />
                        </div>
                        <HeadLines
                          text={`₹ ${data?.ltpUtilizedLimit.toLocaleString()}`}
                          className={`${
                            isMobile
                              ? "font-size14 line-height16 letterSpacing005"
                              : "font-size16 line-height19 letterSpacing015"
                          } colorDark1 font-weight700 margin-left8`}
                        />
                      </div>
                    </div>
                    <MultiProgressBar
                      totalLimit={data?.utilizedLimit}
                      stpLimit={data?.stpUtilizedLimit}
                      ltpLimit={data?.ltpUtilizedLimit}
                    />
                  </div>
                </>
              ) : (
                <div
                  className={`${style["noTradeLimit"]} d-flex align-items-center justify-content-center gap32`}
                >
                  <img
                    src={MoneyWallet}
                    style={{
                      width: isMobile ? "31px" : "55px",
                      height: isMobile ? "31px" : "55px",
                    }}
                  />
                  <HeadLines
                    text="Unlock Aryatech Trade Procurement Facility"
                    className={`${
                      isMobile
                        ? "font-size14 line-height16 letterSpacing005 font-weight400 colorAccent3"
                        : "font-size20 line-height24 letterSpacing015 font-weight500 colorDark14"
                    }textCenter`}
                  />

                  <Button
                    title={isMobile ? "Apply Loan" : "Apply Now"}
                    onClick={handleApply}
                    className={`${
                      isMobile
                        ? style["mobileApplyButton"]
                        : style["desktopApplyButton"]
                    } cursorPointer`}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyTradeLimit;
